package com.arena_web.ui.components.navigation

import androidx.compose.runtime.Composable
import com.arena_web.ui.theme.AppGradients
import com.arena_web.ui.utils.sBorderRadius
import com.arena_web.ui.utils.sSize
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.BoxScope
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import org.jetbrains.compose.web.css.*

@Composable
fun HeaderNavButton(
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    size: Int = 44,
    overrideBackground: Boolean = false,
    content: @Composable BoxScope.() -> Unit
) {
    Box(
        modifier = Modifier
            .sSize(size)
            .sBorderRadius(100)
            .cursor(Cursor.Pointer)
            .position(Position.Relative)
            // Marker class: AppTheme darkens the pale-blue glyphs inside
            // these buttons on the light theme ([data-theme=light] rule).
            .classNames("arena-hnb")
            .then(
                if (!overrideBackground) Modifier.styleModifier {
                    property("border", "0.3px solid transparent")
                    property(
                        "background",
                        "${AppGradients.InteractiveSecondary} padding-box, " +
                            "linear-gradient(0deg, var(--arena-bg), var(--arena-bg)) padding-box, " +
                            "${AppGradients.ButtonBorderGradientPrimary} border-box"
                    )
                } else Modifier
            )
            .then(modifier)
            .onClick { onClick() },
        contentAlignment = Alignment.Center,
        content = content
    )
}
